// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail[data-v-0244b79a],.detail .certificate-img[data-v-0244b79a]{position:relative}.detail .back-btn[data-v-0244b79a]{color:#fff;right:40px}.detail .back-btn[data-v-0244b79a],.detail .down-btn[data-v-0244b79a]{font-size:16px;position:absolute;top:0;cursor:pointer}.detail .down-btn[data-v-0244b79a]{right:140px}", ""]);
// Exports
module.exports = exports;
